import React, { useEffect, useState } from "react";
import AddImage from "../../../../assets/icons/add-image.svg";
import { EditOutlined } from "@mui/icons-material";
import "../../../../assets/styles/variables.scss";
import LearnMoreButton from "./LearnMore";
import ImageUpload from "../upload-image";

interface MainSectionProps {
  isForSharing: boolean;
  updateTitle?: any;
  title?: string;
  mainSectionData?: any;
  setMainSectionData?: any;
  sectionVisibility?: any;
  setSectionVisibility?: any;
  primaryColor?: string;
  accentColor?: string;
  setImageFiles?: any;
  canWrite?: boolean;
  canDelete?: boolean;
}

const MainSection: React.FC<MainSectionProps> = ({
  isForSharing,
  title,
  mainSectionData,
  setMainSectionData,
  sectionVisibility,
  setSectionVisibility,
  primaryColor,
  accentColor,
  setImageFiles,
  canWrite = false,
  canDelete,
}) => {
  const [editHeading, setEditHeading] = useState(false);
  const [editSubHeading, setEditSubHeading] = useState(false);

  const handleImageChange = (file: any) => {
    setImageFiles((prev: any) => ({
      ...prev,
      "main-section": file,
    }));
    setMainSectionData((prev: any) => ({
      ...prev,
      imageUrl: file ? URL.createObjectURL(file) : "",
    }));
  };

  const handleImageRemove = () => {
    setMainSectionData((prev: any) => ({
      ...prev,
      imageUrl: "",
    }));
    setImageFiles((prev: any) => {
      const { ["main-section"]: _, ...rest } = prev;
      return rest;
    });
  };

  const textColor = isForSharing ? "#fff" : "#fff";

  return (
    <div>
      <div
        id="your-section"
        style={{
          padding: "20px 60px",
          backgroundColor: primaryColor,
          background: primaryColor,
          color: textColor,
          position: "relative",
        }}
      >
        {!isForSharing && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className={
              sectionVisibility?.["partner-success-metrics"] && !isForSharing
                ? "section-header"
                : ""
            }
          >
            {sectionVisibility["main-section"] && (
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  border: "none",
                  background: "transparent",
                  margin: 0,
                  wordBreak: "break-word",
                }}
              >
                {mainSectionData?.title || "Your Heading"}
              </h3>
            )}
            <button
              onClick={() => {
                if (setSectionVisibility) {
                  setSectionVisibility((prev: any) => ({
                    ...prev,
                    "main-section": !prev["main-section"],
                  }));
                }
              }}
              className={
                sectionVisibility?.["partner-success-metrics"]
                  ? "toggle-section-button"
                  : ""
              }
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                backgroundColor: "#fff",
                color: canWrite ? "#000000" : "rgba(0, 0, 0, 0.3)",
                boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                padding: "6px 24px",
                border: "none",
                cursor: canWrite ? "pointer" : "not-allowed",
                width: "147px",
                height: "42px",
                borderRadius: "8px",
                fontSize: "15px",
                fontFamily: "Roboto, sans-serif",
              }}
              disabled={!canWrite}
            >
              {sectionVisibility?.["main-section"]
                ? "Show Section"
                : "Hide Section"}
            </button>
          </div>
        )}

        {!sectionVisibility["main-section"] && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: !isForSharing ? "500px" : "auto",
            }}
            className={"landing-page-main-section"}
          >
            <div
              style={{ maxWidth: "40%" }}
              className={"landing-page-main-section-one"}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {editHeading && !isForSharing ? (
                  <input
                    type="text"
                    value={mainSectionData?.title}
                    onChange={(e) => {
                      setMainSectionData((prev: any) => ({
                        ...prev,
                        title: e.target.value,
                      }));
                    }}
                    onBlur={() => setEditHeading(false)}
                    onFocus={(e) => e.target.select()}
                    autoFocus
                    style={{
                      fontSize: "30px",
                      color: textColor,
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                      borderBottom: "1px solid #ccc",
                      fontWeight: "700",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    maxLength={40}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "30px",
                        margin: 0,
                        fontWeight: "700",
                        letterSpacing: "-0.02rem",
                        width: "auto",
                        maxWidth: "500px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        cursor: "default",
                      }}
                      title={mainSectionData?.title}
                    >
                      {mainSectionData?.title}
                    </h3>
                    {!isForSharing && (
                      <button
                        onClick={() => setEditHeading(true)}
                        style={{
                          background: "#fff",
                          border: "none",
                          cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "50%",
                          padding: "4px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        disabled={!canWrite}
                      >
                        <EditOutlined fontSize="small" />
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: "10px",
                }}
                className={"landing-page-main-section-one-main-subtitle"}
              >
                {editSubHeading && !isForSharing ? (
                  <input
                    type="text"
                    value={mainSectionData?.subTitle}
                    onChange={(e) => {
                      setMainSectionData((prev: any) => ({
                        ...prev,
                        subTitle: e.target.value,
                      }));
                    }}
                    onBlur={() => setEditSubHeading(false)}
                    autoFocus
                    onFocus={(e) => e.target.select()}
                    style={{
                      color: textColor,
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                      borderBottom: "1px solid #ccc",
                      fontSize: "18px",
                      fontWeight: "400",
                      margin: "24px 10px",
                      width: "450px",
                      fontFamily: "Roboto, sans-serif",
                    }}
                    maxLength={75}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                    className="landing-page-main-section-one-subtitle"
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "400",
                        letterSpacing: "-0.02rem",
                        width: "auto",
                        maxWidth: "500px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: "30px",
                      }}
                      title={mainSectionData?.subTitle}
                    >
                      {mainSectionData?.subTitle}
                    </p>
                    {!isForSharing && (
                      <button
                        onClick={() => setEditSubHeading(true)}
                        style={{
                          background: "#fff",
                          border: "none",
                          cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "50%",
                          padding: "4px",
                          fontFamily: "Roboto, sans-serif",
                        }}
                        disabled={!canWrite}
                      >
                        <EditOutlined fontSize="small" />
                      </button>
                    )}
                  </div>
                )}
              </div>
              <div
                className="learn-more-button-wrapper"
                style={{
                  justifyContent: "flex-start",
                  marginTop: "1rem",
                  display: "flex",
                }}
              >
                {!(isForSharing && !mainSectionData?.btnUrl?.trim()) && (
                  <LearnMoreButton
                    isForSharing={isForSharing}
                    primaryColor={accentColor}
                    link={mainSectionData?.btnUrl}
                    setLink={setMainSectionData}
                    canWrite={canWrite}
                  />
                )}
              </div>
            </div>

            <div
              style={{ width: "50%" }}
              className={"landing-page-main-section-two"}
            >
              <div
                style={{
                  height: 400,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: isForSharing ? "default" : "pointer",
                  position: "relative",
                }}
              >
                {!isForSharing || mainSectionData?.imageUrl ? (
                  <div>
                    <ImageUpload
                      imageUrl={mainSectionData?.imageUrl || ""}
                      onImageChange={handleImageChange}
                      onImageRemove={handleImageRemove}
                      isForSharing={isForSharing}
                      placeholderImage={AddImage}
                      sectionName="main-section"
                      canWrite={canWrite}
                    />
                  </div>
                ) : (
                  <div style={{ width: "50%" }}></div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainSection;
